<template>
    <div class="flex transfer">
        <div class="left">
            <el-tooltip class="item" effect="dark" content="加入发车单" placement="top">
                <el-button  @click="moveDown" class="up-down" type="text" icon="el-icon-bottom"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="移除发车单" placement="top">
                <el-button @click="moveUp" class="up-down" type="text" icon="el-icon-top"></el-button>
            </el-tooltip>
            <span class="left-info">
                <span class="target-sel">{{tarSelRoot.vehicleCard || ''}}</span>
                <span class="target-sel dispatch-no" title="点击可复制" @click="dispatchNoCopy($event)">{{tarSelRoot.dispatchNo || ''}}</span>
                <span class="">单量：<span class="content">{{taskTotalQty}}</span></span>
                <span class="">数量：<span class="content">{{taskTotalCount}}</span></span>
                <span>方量(m³)：<span class="content">{{taskTotalVolume}}</span></span>
                <span>重量(KG)：<span class="content">{{taskTotalWeight}}</span></span>
                <i class="el-icon-view" @click="handleDetailStatistics"></i>
            </span>
        </div>
        <div class="right">
            <div class="btn-content">
                <el-button class="btn-content_button" v-show="showConfirmBtn" @click="newDispOrder">新建发车单</el-button>
            </div>
            <div class="btn-content" v-has="'otp02010001'">
                <el-button class="btn-content_button" :disabled="transDisable" v-show="showTransBtn" @click="handleTransfer">转移</el-button>
            </div>
            <div class="btn-content" v-has="'otp02010002'">
                <el-button class="btn-content_button" :disabled="confDisable" v-show="showConfirmBtn" @click="arrangeConfirm" :loading="confirmLoading">确认</el-button>
            </div>
            <div class="btn-content" v-has="'otp02010003'">
                <el-button class="btn-content_button" v-show="showScheduleBtn" @click="intelliArrange">智能排车</el-button>
            </div>
            <div class="btn-content" v-has="'otp02010004'">
                <el-button class="btn-content_button" v-show="showScheduleBtn" @click="submitArrange">排车</el-button>
            </div>
        </div>
        <el-dialog title="查看明细" :visible.sync="detailVisible" append-to-body width="65%">
            <el-table border :data="detailStatistics">
                <el-table-column property="customerItemCode" label="客户商品编码" width="130" sortable show-overflow-tooltip></el-table-column>
                <el-table-column property="itemName" label="商品名称" width="300" sortable show-overflow-tooltip></el-table-column>
                <el-table-column property="itemClass" label="商品分类" sortable show-overflow-tooltip></el-table-column>
                <el-table-column property="planQty" label="数量" sortable></el-table-column>
                <el-table-column property="volume" label="方量(m³)" sortable></el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="转移" :visible.sync="transferVisi" width="40%" @close="transClose" append-to-body>
            <el-radio v-model="identify" label="1" @change="transferLabelChange">已有发车单
                <el-select v-model="value" filterable @focus="handleSelChange" :filter-method="transTreeFilterMethod" clearable>
                    <el-option v-for="(item, index) in transTreeLimit" :key="'dispatchNo'+index" :label="item.dispatchNo" :value="item.dispatchNo"></el-option>
                </el-select>
            </el-radio>
            <el-radio v-model="identify" label="2" @change="transferLabelChange">新建发车单</el-radio>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancel">取 消</el-button>
                <el-button type="primary" :disabled="isDisable" @click="handleSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import _ from '@/components/lots/utils';
import { rowCarCheck, addOrderCheck, verifyLBX, getMesTip, minusVerifyLBXOrder, lineOperationCheck, appointmentCheck } from '../../../utils/dispatchCenter.js';
import { getDetailStatistics, updateCarArrange, updateIntelliArrange, getTransferData, getTargetRoot, algorithmLine } from '../../../api/sieveSingleCenter';

const DISPATCH_STATUS_IN_TRANSIT = 40; // 发车单状态-在途

export default {
    props: {
        flag: {
            type: String,
            default() {
                return '';
            }
        },
        tarSelRoot: {
            type: Object,
            default() {
                return {};
            }
        },
        totalTargetData: {
            type: Array,
            default() {
                return [];
            }
        },
        mulTotalData: { // 上表格应该展示的所有数据（1000条的分页）
            type: Array,
            default() {
                return [];
            }
        },
        realTotalTargetData: { // 下表格所有的数据
            type: Array,
            default() {
                return [];
            }
        },
        cheList: {
            type: Array,
            default() {
                return [];
            }
        },
        transDisable: {
            type: Boolean,
            default() {
                return false;
            }
        },
        confDisable: {
            type: Boolean,
            default() {
                return false;
            }
        },
        groupPolicyCode: {
            type: String,
            default() {
                return undefined;
            }
        },
        groupPolicyVal: {
            type: String,
            default() {
                return undefined;
            }
        },
        groupPolicyValArr: {
            type: Array,
            default() {
                return [];
            }
        },
        sourceTree: {
            type: Array,
            default() {
                return [];
            }
        },
        currWarehouseGroup: {
            type: String,
            default() {
                return undefined;
            }
        },
        currInOutType: {
            type: String,
            default() {
                return undefined;
            }
        },
        checkedSourceList: {
            type: Array,
            default() {
                return [];
            }
        },
        appointmentSiteCodeWhiteList: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data() {
        return {
            identify: this.flag,
            btnEnum: {
                confirm: ['0'],
                transConfirm: ['6','10', '20', '30'],
                schedule: [undefined]
            },
            confirmLoading: false,
            detailVisible: false,
            detailStatistics: [],
            showConfirmBtn: false,
            showTransBtn: false,
            showScheduleBtn: true,
            isDisable: false,
            value: '',
            transTreeFilter: [],
            transferVerifyLBXOrderRes: [],
            transferVisi: false,
            groupPolicyValArrNew: this.groupPolicyValArr
        };
    },
    computed: {
        taskTotalQty: function() {
            return this.realTotalTargetData.length;
        },
        taskTotalVolume: function() {
            return this.realTotalTargetData.reduce((partical, value) => {
                const taskTotalVolume = partical + (value.totalVolume || 0);
                return Math.round(taskTotalVolume * 1000000) / 1000000;
            }, 0);
        },
        taskTotalWeight: function() {
            return this.realTotalTargetData.reduce((partical, value) => {
                const taskTotalWeight = partical + (value.totalGrossWeight || 0);
                return Math.round(taskTotalWeight * 1000) / 1000;
            }, 0);
        },
        taskTotalCount: function() {
            return this.realTotalTargetData.reduce((partical, value) => {
                const taskTotalCount = partical + (value.totalQty || 0);
                return Math.round(taskTotalCount * 1000) / 1000;
            }, 0);
        },
        transTreeLimit: function() {
            if (this.transTreeFilter.length < 10) {
                return this.transTreeFilter;
            } else {
                return this.transTreeFilter.slice(0, 10);
            }
        },
    },
    watch: {
        'tarSelRoot.dispatchStatus': function (newStatus) {
            if (this.btnEnum.confirm.includes(newStatus + '')) {
                this.showConfirmBtn = true;
                this.showScheduleBtn = this.showTransBtn = false;
                return;
            }
            if (this.btnEnum.transConfirm.includes(newStatus + '')) {
                this.showConfirmBtn = this.showTransBtn = true;
                this.showScheduleBtn = false;
                return;
            }
            if (this.btnEnum.schedule.includes(newStatus)) {
                this.showConfirmBtn = this.showTransBtn = false;
                this.showScheduleBtn = true;
                return;
            }
            this.showScheduleBtn = this.showConfirmBtn = this.showTransBtn = false;
        }
    },
    methods: {
        handleDetailStatistics() {
            this.detailVisible = true;
            const taskNoList = this.realTotalTargetData.map(item => item.taskNo);
            getDetailStatistics(taskNoList).then(res => {
                if (res) {
                    this.detailStatistics = res.data.list || [];
                }
            });
        },
        newDispOrder() {
            this.$emit('newDispOrder');
        },
        handleTransfer () {
            const cheList = this.cheList;
            if (cheList.length === 0) return this.$message.warning('至少选择一条运输单!');
            if (+this.tarSelRoot.gainingContract === 1) return this.$message.warning('正在获取合同号中，不能转移');
            for (var i = 0; i < cheList.length; i++) {
                if (+cheList[i].taskStatus === 30 && ['YS', 'OUT'].includes(cheList[i].inOutType) &&
                    cheList[i].sourceSystem === 'CIMS' && +cheList[i].distributionNum === 1 && cheList[i].orderSource === 'API') {
                    return this.$message.warning(`存在不能转移的运输单：${cheList[i].taskNo}`);
                }
                // if (cheList[i].planOrderFlagName !== cheList[0].planOrderFlagName) return this.$message.warning('模糊和非模糊订单不能一起转移，有问题请联系郑右云');
            };
            if (this.tarSelRoot.dispatchNo && cheList[0].sourceSystem === 'LONGI-WBKH' && this.realTotalTargetData.length !== cheList.length) {
                return this.$message.warning(`隆基客户单排车后不允许部分转移，仅允许全部转移`);
            }
            this.transferVerifyLBXOrderRes = minusVerifyLBXOrder(cheList, this.realTotalTargetData);
            this.transferVisi = true;
        },
       async arrangeConfirm () {
            if (+this.tarSelRoot.gainingContract) return this.$message.warning('获取合同号中，不可以确认');
            // if (this.realTotalTargetData.find(el => el.planOrderFlagName !== this.realTotalTargetData[0].planOrderFlagName)) return this.$message.warning('模糊和非模糊订单不能一起确认，有问题请联系郑右云');
            const params = {
                dispatchNo: this.tarSelRoot.dispatchNo,
                dispatchStatus: this.tarSelRoot.dispatchStatus,
                transportList: this.realTotalTargetData,
                vehicleCard: this.tarSelRoot.vehicleCard,
                volume: this.taskTotalVolume,
                procurementChannel: this.tarSelRoot.procurementChannel,
                carrierCode: this.tarSelRoot.carrierCode,
                preDispatchType: '2', // 调度类型
                operateSystem: 'LSP'//区分系统
            };
            if (await lineOperationCheck(this.tarSelRoot, this.realTotalTargetData)) {
                params.directlyControlledRecord = {
                    firstReasonType: '0',
                    firstReasonValue: '其他',
                    secondReasonType: '0-1',
                    secondReasonValue: '运单已从OTP下发供应商LSP，供应商有变更操作记录，请做好确认及监控！',
                    reasonDialogVisible: true,
                    directControlTransportCapacityFlag: false
                }
            } else {
                params.directlyControlledRecord = {
                    reasonDialogVisible: false,
                    directControlTransportCapacityFlag: true
                }
            }
            this.confirmLoading = true;
            if (+this.tarSelRoot.intelligentFlag === 0) {
                const data = {
                    ...params,
                    operateEntrance: 'LSP'
                };
                // 配置特权后请求需要添加特权参数
                if (this.isPrivilege) {
                    data['isPrivilege'] = 'Y';
                }
                updateCarArrange(data).then(res => {
                    this.confirmLoading = false;
                    if (res) this.$message.success('确认成功');
                    this.$emit('arrangeConfirmOk', this.tarSelRoot.dispatchNo);
                }).catch(() => {
                    this.confirmLoading = false;
                });
            } else {
                const data = {
                    biz: 'tsp',
                    intelligentFlag: this.tarSelRoot.intelligentFlag,
                    ...params
                };
                updateIntelliArrange(data).then(res => {
                    this.confirmLoading = false;
                    if (res) this.$message.success('确认成功');
                    this.$emit('arrangeConfirmOk', this.tarSelRoot.dispatchNo);
                }).catch(() => {
                    this.confirmLoading = false;
                });
            }
        },
        intelliArrange() {
            this.$emit('intelArr');
        },
        submitArrange(type = true) {
            if (!this.realTotalTargetData.length) {
                this.$message.warning('请至少选择一条运输单');
                return;
            }
            const planOrderFlagDiff = this.realTotalTargetData.find((item, index) => {
                if (item.planOrderFlagName !== this.realTotalTargetData[0].planOrderFlagName) return true;
            });
            // if (planOrderFlagDiff) return this.$message.warning('模糊订单不能与正常订单一起排车，有问题请联系郑右云');
            setTimeout(() => {
                this.realTotalTargetData.forEach((item, index, arr) => {
                    if (item.consolidationOrderNo && item.consolidationNum) {
                        const totalCount = arr.filter(item2 => item2.consolidationOrderNo === item.consolidationOrderNo).length;
                        if (totalCount < item.consolidationNum) {
                            this.$message.warning({
                                message: `集拼单号：${item.consolidationOrderNo}未齐套,集拼单量应为：${item.consolidationNum}个,目前只勾选${totalCount}个，如有疑问请咨询基地！`,
                                duration: 5000
                            });
                        }
                    }
                });
            }, 50);
            if (this.realTotalTargetData[0].sourceSystem === 'LONGI-WBKH' && +this.realTotalTargetData[0].defineInt1 !== this.realTotalTargetData.length) {
                return this.$message.warning(`平台单号${this.realTotalTargetData[0].platformOrderNo}包含${this.realTotalTargetData[0].defineInt1}个客户订单，请全部审核下发后再排车`);
            }
            const distributionWhFlag = this.realTotalTargetData.find(item => item.distributionWhCode);
            if (distributionWhFlag) {
                this.$confirm('勾选任务中存在继续分拨订单，请确认是否继续！', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (this.tarSelRoot.status === undefined) {
                        if (type) {
                            this.$emit('arraVisi');
                        } else {
                            this.handeleAlgorithmLine();
                        }
                    }
                }).catch(() => {});
            } else {
                if (this.tarSelRoot.status === undefined) {
                    if (type) {
                        this.$emit('arraVisi');
                    } else {
                        this.handeleAlgorithmLine();
                    }
                }
            }
        },
        // 算法排车
        handeleAlgorithmLine() {
            const orders = [];
            this.realTotalTargetData.forEach(item => {
                orders.push({ id: item.id });
            });
            algorithmLine({ orders }).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('提交算法排单成功，请到排单列表查看排单进度！');
                    this.$emit('leftList');
                }
            });
        },
        dispatchNoCopy(e) {
            var input = document.createElement('input');
            input.type = 'text';
            input.value = (e.target.innerHTML).trim();
            e.target.appendChild(input);
            input.select();
            document.execCommand('copy');
            e.target.removeChild(input);
            this.$message.success(`发车单号‘${input.value}’复制成功`);
        },
        handleCancel() { // 关闭转移选择转移类型的弹窗
            this.transferVisi = false;
            this.identify = '';
            this.value = '';
        },
       async handleSubmit () {
            if (+this.identify === 2) {
                this.$emit('arraVisi', this.identify);
                this.transferVisi = false;
            } else if (+this.identify === 1) {
                this.isDisable = true;
                const obj = {
                    flag: +this.identify,
                    oldDispatchNo: this.tarSelRoot.dispatchNo,
                    newDispatchNo: this.value,
                    dispatchStatus: this.tarSelRoot.dispatchStatus,
                    transportList: this.transferVerifyLBXOrderRes,
                    gainingContract: this.tarSelRoot.gainingContract,
                    carrierCode: this.tarSelRoot.carrierCode,
                    preDispatchType: '2', // 调度类型  1人工调度 2算法调度 3线路调度
                    operateSystem: 'LSP',//区分系统
                    operateEntrance: 'LSP'
                };
                if (await lineOperationCheck(this.transTreeLimit.filter(v => v.dispatchNo === this.value)[0], this.transferVerifyLBXOrderRes)) {
                obj.directlyControlledRecord = {
                    firstReasonType: '0',
                    firstReasonValue: '其他',
                    secondReasonType: '0-1',
                    secondReasonValue: '运单已从OTP下发供应商LSP，供应商有变更操作记录，请做好确认及监控！',
                    reasonDialogVisible: true,
                    directControlTransportCapacityFlag: false
                }
                } else {
                    obj.directlyControlledRecord = {
                        reasonDialogVisible: false,
                        directControlTransportCapacityFlag: true
                    }
                }
                if ((this.transTreeLimit.filter(v => v.dispatchNo === this.value)[0]).directControlFlag) {
                    obj.directlyControlledRecord.directControlTransportCapacityFlag = false;
                }
                getTransferData(obj).then(res => {
                    this.isDisable = false;
                    if (res) {
                        this.handleCancel();
                        const genDispatchNo = res.data.indexOf(',') < 0 ? res.data : res.data.split(',')[0];
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: `<div>
                                <span>转移成功，生成发车单号：${res.data}</span>
                                <a id="copyTraCNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                            </div>`,
                            type: 'success',
                            duration: 5000
                        });
                        document.getElementById('copyTraCNo').addEventListener('click', () => {
                            this.copyText(document.body, genDispatchNo, false);
                        });
                        this.$emit('leftList');
                    };
                }).catch(() => {
                    this.isDisable = false;
                });
            }
        },
        transClose () {
            this.transTreeFilter = [];
            this.value = '';
            this.identify = '';
        },
        handleSelChange() {
            this.getTargetList();
            this.identify = '1';
        },
        transTreeFilterMethod(val) {
            this.value = val;
            this.$nextTick(() => {
                this.getTargetList();
            });
        },
        moveUp() {
            const targetTabelData = this.cheList;
            if (this.cheList.length === 0) return this.$message.warning('请至少勾选一条数据');
            if (+this.tarSelRoot.gainingContract) {
                this.$message.warning('获取合同号中，不可以加单');
            } else {
                for (let i = 0; i < targetTabelData.length; i++) {
                    if (targetTabelData[i].logisticMode !== 'WT' && +targetTabelData[i].taskStatus === 30 && targetTabelData[i].dispatchNo &&
                    (targetTabelData[i].inOutType === 'OUT' || targetTabelData[i].inOutType === 'YS')) {
                        return this.$message.warning(`存在不能减单的运输单：${targetTabelData[i].taskNo}`);
                    }
                    if (this.isPrivilege && targetTabelData[i].logisticMode === 'WT' && targetTabelData[i].taskStatus >= DISPATCH_STATUS_IN_TRANSIT) {
                        return this.$message.warning(`仓配分离运输单：${targetTabelData[i].taskNo} 是在途前的状态才能减单`);
                    }
                }
                if (this.tarSelRoot.dispatchNo && targetTabelData[0].sourceSystem === 'LONGI-WBKH' && this.realTotalTargetData.length !== targetTabelData.length) {
                    return this.$message.warning(`隆基客户单排车后不允许部分减单，仅允许全部减单`);
                }
                const minusVerifyLBXOrderRes = minusVerifyLBXOrder(targetTabelData, this.realTotalTargetData);
                const targetDataTaskNo = minusVerifyLBXOrderRes.map(el => el.taskNo);
                const targetClone = this.realTotalTargetData.filter(el => !targetDataTaskNo.includes(el.taskNo));
                const currentGroupPolicyData = []; // 在当前分组下要拖的数据
                this.groupPolicyValArrNew = [];
                this.sourceTree.forEach(item => {
                    if (item.isActive) this.groupPolicyValArrNew.push(item[this.groupPolicyCode]);
                });
                minusVerifyLBXOrderRes.forEach(item => {
                    if (this.groupPolicyValArrNew.includes(item[this.groupPolicyCode])) currentGroupPolicyData.push(item);
                });
                const curGrototalDataClone = [].concat(this.mulTotalData);
                const targetTabelTask = curGrototalDataClone.map(el => el.taskNo);
                let sourceData = this.mulTotalData;
                currentGroupPolicyData.forEach(item => {
                    if (this.groupPolicyValArrNew.length === 0) {
                        sourceData = [];
                    } else if (this.groupPolicyValArrNew.includes(item[this.groupPolicyCode]) && !targetTabelTask.includes(item.taskNo)) {
                        sourceData.unshift(item);
                    }
                });
                this.$emit('totalDataChange', targetClone, sourceData);
            }
        },
        moveDown() {
            if (this.checkedSourceList.length === 0) return this.$message.warning('请至少勾选一条数据');

            const rows2Transfer = this.checkedSourceList;
            if (+this.tarSelRoot.dispatchStatus >= DISPATCH_STATUS_IN_TRANSIT) {
                for (let i = 0; i < rows2Transfer.length; i++) {
                    if (rows2Transfer[i].logisticMode === 'WT') return this.$message.warning('发车单不是在途前的状态，不允许加仓配分离订单');
                }
            }
            if (this.isPrivilege && rows2Transfer.some(item => item.logisticMode === 'WT') && rows2Transfer.some(item => item.scanNum > 0) && rows2Transfer.every(item => +item.dispatchType !== 0)) {
                return this.$message.warning('直通宝已扫码，请在直通宝完成后续操作');
            }

            let rowCarCheckRes = '';
            const realTotalData = this.mulTotalData;
            const verifyLBXRes = verifyLBX(rows2Transfer, realTotalData);
            if (this.totalTargetData.length <= 0) {
                rowCarCheckRes = rowCarCheck(rows2Transfer);
            } else {
                rowCarCheckRes = rowCarCheck(this.realTotalTargetData);
                if (!rowCarCheckRes) rowCarCheckRes = rowCarCheck(rows2Transfer, this.realTotalTargetData[0], this.realTotalTargetData);
                if (!rowCarCheckRes) rowCarCheckRes = addOrderCheck(this.realTotalTargetData, rows2Transfer);
            }
            if (rowCarCheckRes) {
                return this.$message.warning(rowCarCheckRes);
            } else if (_.isObject(verifyLBXRes)) {
                return getMesTip(verifyLBXRes, this);
            } else {
                this.continueMoveDown(verifyLBXRes);
            }
        },
        async continueMoveDown (verifyLBXRes) {
            const customerOrderNoList = appointmentCheck(verifyLBXRes, this.appointmentSiteCodeWhiteList);
            if (customerOrderNoList.length) {
                await this.$confirm(`以下客户订单号需要先预约才能排车<br/>${customerOrderNoList.join('<br/>')}`, '提醒', {
                    confirmButtonText: '剔除后加入',
                    cancelButtonText: '取消',
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    // 剔除不符合的tk单
                    verifyLBXRes = verifyLBXRes.filter(x => !customerOrderNoList.includes(x.customerOrderNo));
                    const totalTargetDataNew = [
                        ...verifyLBXRes,
                        ...this.realTotalTargetData
                    ];
                    const transTaskNo = verifyLBXRes.map(el => el.taskNo);
                    const totalDataNew = this.mulTotalData.filter(el => !transTaskNo.includes(el.taskNo));
                    this.$emit('totalDataChange', totalTargetDataNew, totalDataNew, true);
                }).catch(() => {
                    return false;
                });
            } else {
                const totalTargetDataNew = [
                    ...verifyLBXRes,
                    ...this.realTotalTargetData
                ];
                const transTaskNo = verifyLBXRes.map(el => el.taskNo);
                const totalDataNew = this.mulTotalData.filter(el => !transTaskNo.includes(el.taskNo));
                this.$emit('totalDataChange', totalTargetDataNew, totalDataNew, true);
            }
        },
        transferLabelChange(label) {
            if (label === '2') {
                this.$emit('arraVisi', this.identify);
                this.transferVisi = false;
            }
        },
        copyText(cellEl, copyText, classFlag) {
            if (cellEl.className && classFlag) {
                return;
            }
            var input = document.createElement('input');
            input.type = 'text';
            input.value = copyText.trim();
            cellEl.appendChild(input);
            input.select();
            document.execCommand('copy');
            cellEl.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        getTargetList() {
            const params = {
                dispatchStatus: '0,6,10,20,30',
                dispatchNo: this.value.trim()
            };
            getTargetRoot(params).then(res => {
                if (res) {
                    this.transTreeFilter = (res.data.list || []).filter(item => item.intelligentStatus !== 10 && item.dispatchNo !== this.tarSelRoot.dispatchNo);
                }
            });
        }
    }
};
</script>
<style lang="less">
.transfer {
    .dialog-footer {
        text-align: right;
        margin-top: 15px;
    }
    .up-down {
        font-size: 18px;
        margin-left: 0px;
        margin-right: 10px;
    }
    .right {
        .btn-content {
            display: inline-block;
        }
        .btn-content_button {
            margin-left: 10px;
        }
    }
}
</style>
